import { useMemo } from 'react';

import { useReport } from '../context/ReportContext';
import { MetricsHelper } from '../helpers/MetricsHelper';
import { PeriodHelper } from '../helpers/PeriodHelper';
import type { IComponentFacts, IReportItem } from '../types/report';

/** Resolves one report item's effective period (report filter + override) against the fact table. */
export const useComponentFacts = (item: IReportItem): IComponentFacts => {
  const { table, filter } = useReport();
  return useMemo(() => {
    const effective = PeriodHelper.mergeFilter(filter, item.override);
    const resolved = PeriodHelper.resolve(
      effective,
      table.booksClosedThrough,
      table.fiscalYearStartMonth
    );
    return {
      ...MetricsHelper.compare(table, resolved),
      table,
      resolved,
      filter: effective,
      currency: table.currency,
      hasOverride: Boolean(item.override),
    };
  }, [table, filter, item.override]);
};
